export class Flows {
  constructor () {
    this.flowsData = {}
  }

  add (stage, fromState, toState, demographicValue, size) {
    let flow = this.getFlow(stage, fromState, toState, demographicValue)
    this.setFlow(stage, fromState, toState, demographicValue, {
      size: flow ? flow.size + size : size
    })
  }

  setFlow (stage, fromState, toState, demographicValue, flow) {
    const fromStateData = this.flowsData[stage]
    if (fromStateData) {
      const toStateData = this.flowsData[stage][fromState]
      if (toStateData) {
        const demographicFlowData = this.flowsData[stage][fromState][toState]
        if (demographicFlowData) {
          const flowData = this.flowsData[stage][fromState][toState][demographicValue]
          if (flowData) {
            Object.assign(flowData, flow)
          } else {
            demographicFlowData[demographicValue] = flow
          }
        } else {
          toStateData[toState] = {
            [demographicValue]: flow
          }
        }
      } else {
        fromStateData[fromState] = {
          [toState]: {
            [demographicValue]: flow
          }
        }
      }
    } else {
      this.flowsData[stage] = {
        [fromState]: {
          [toState]: {
            [demographicValue]: flow
          }
        }
      }
    }
  }

  getFlow (stage, fromState, toState, demographicValue) {
    return this.flowsData[stage] && this.flowsData[stage][fromState] && this.flowsData[stage][fromState][toState] && this.flowsData[stage][fromState][toState][demographicValue]
  }

  getAllFlows () {
    return this.flowsData
  }

  iterate (iteratorFunction) {
    for (const stage in this.flowsData) {
      const fromStateData = this.flowsData[stage]

      for (const fromState in fromStateData) {
        const toStateData = fromStateData[fromState]

        for (const toState in toStateData) {
          const demographicFlowData = toStateData[toState]

          for (const demographicValue in demographicFlowData) {
            const flow = demographicFlowData[demographicValue]
            iteratorFunction(flow, stage, fromState, toState, demographicValue)
          }
        }
      }
    }
  }
}
